<template>
  <article class="relative flex flex-col items-start justify-between">
    <div class="relative w-full">
      <img
        :src="image"
        :alt="title"
        class="aspect-video w-full rounded-2xl bg-gray-100 object-cover sm:aspect-2/1 lg:aspect-3/2"
      >
      <div class="absolute inset-0 rounded-2xl inset-ring inset-ring-gray-900/10" />
    </div>

    <div class="flex max-w-xl grow flex-col justify-between">
      <div class="mt-4 flex items-center gap-x-4 text-xs font-medium text-gray-500">
        {{ category }}
      </div>

      <div class="group grow">
        <THeading
          :level="5"
          tag="h4"
          class="mt-3 text-gray-900 group-hover:text-primary-600"
        >
          <NuxtLink :to="to">
            <span class="absolute inset-0" />
            {{ title }}
          </NuxtLink>
        </THeading>

        <p
          v-if="summary"
          class="mt-5 line-clamp-3 text-sm/6 text-gray-600"
        >
          {{ summary }}
        </p>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
defineProps<{
  image: string
  title: string
  to?: string
  category?: string
  summary?: string
}>()
</script>
